import React, { useState } from "react";
import { Button, Input } from "./Form";
import Modal from "./Modals/Modal";
import { FaSave } from "react-icons/fa";

function NewExtra({modal, setModal, state, setState, className, label= 'Add New Extra', onClick, loading}) {
	// const [modal, setModal] = useState(false);

  const handleChange = (e) => {
    setState({ ...state, [e.target.name]: e.target.value });
  }

	return (
		<>
			{/* <Button
				className={`flex max-w-fit px-4 items-center ${className}`}
				Icon={() => (<IoAdd className="font-bold" size={16} />)}
				label={label}
				onClick={() => setModal(true)}
			/> */}
			<Modal isOpen={modal} closeModal={() => setModal(false)} title={"Edit Product Extra"}>
				<Input label={"Name *"} placeholder={"Metal ceramic, Zirconia, ..."} color name="name" value={state?.name} onChange={handleChange} />
				<Input label={"Price (BAM)"} placeholder={"Price"} color type={"number"} min={0} name="price" value={state?.price} onChange={handleChange} />
				<Button className={"my-4"} label={"Save"} Icon={FaSave} loading={loading} onClick={onClick} />
			</Modal>
		</>
	);
}

export default NewExtra;
